import UserTableContainer from './UserTableContainer';

export default UserTableContainer;
